<template>
  <el-container class="tags-view-container">
    <!-- <el-tabs v-model="activeName" style="width: 100%" type="border-card">
      <el-tab-pane
        v-for="(item, index) in tabRoutes"
        :key="item.name ==='reportQuery'?item.name+item.query.reportid:item.name"
        :label="item.meta.title"
        :name="item.name ==='reportQuery'?item.name+item.query.reportid:item.name">
        <span slot="label"><i class="el-icon-s-flag" v-if="(item.name ==='reportQuery'?item.name+item.query.reportid:item.name)===activeName"></i>
          <router-link :to="{ name: item.name, query: item.query, params: item.params}">
            <span v-if="item.name ==='reportQuery'">{{item.query.title}}</span>
            <span v-else="">{{item.meta.title}}</span>
          </router-link>
          <i class="el-icon-close" v-if="item.name!=='mainIndex'" @click="close(item.name ==='reportQuery'?item.name+item.query.reportid:item.name)" ></i>
        </span>
      </el-tab-pane>
    </el-tabs> -->
    <div class="reuse-tab">
      <swiper :options="swiperOption" class="reuse-tab-wrap">
         <swiper-slide style="min-width:50px;width: 50px;height: 50px;line-height:50px">
         <div class="fold" >
        <i :class="menuIcon" @click="setCollapse"></i>
      </div>
      </swiper-slide>
        <swiper-slide v-for="(item, index) in tabRoutes" :key="item.name">
          <router-link 
            class="reuse-tab-item"
            :class="item.path === currentPath ? 'active' : ''"
            :to="{ name: item.name, query: item.query, params: item.params}">
            <span v-if="item.name ==='reportQuery'">{{item.meta.title}}</span>
            <span v-else="">{{item.meta.title}}</span>
            <span class="el-icon-close" v-if="tabRoutes.length - 1 > 0" @click.prevent.stop="close(item.name)"/>
          </router-link>
        </swiper-slide>
     </swiper>
    </div>
  </el-container>
</template>
<script>
  import {mapGetters} from 'vuex'
  import request from '@/utils/request'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import 'swiper/swiper.css'
  export default {
    components: { swiper, swiperSlide },
    name: 'explorer',
    data () {
      return {
        swiperOption: {
          slidesPerView: 'auto',
          initialSlide: 0,
          effect: 'slide',
          spaceBetween: 1,
          preventClicks: false,
          freeMode: true,
          mousewheel: {
            sensitivity: 1.5,
          },
        },
        currentPath: ''
     }
    },
    computed: {
      ...mapGetters(['tabRoutes', 'isCollapse', 'ispbrCenterClose', 'ispbrTenderFormClose', 'isauctionHallClose', 'pbrCenterInfo']),
      activeName: {
        get () {
          return this.$store.state.tabs.activeName
        },
        set (val) {
          this.$store.commit('set_active_name', val)
        }
      },
      menuIcon () {
        return this.isCollapse ? 'el-icon-s-unfold'  :'el-icon-s-fold'
      }
    },
    mounted () {
      let activeName = this.$store.state.tabs.activeName
      this.$router.push({name: activeName.name, params: activeName.params})
    },
    methods: {
      setCollapse () {
        this.$store.commit('SET_ISCOLLAPSE', !this.isCollapse)
      },
      tabClick(tab, event) {
        //let func = this.tabRoutes.find(item => {return item.name === tab.name})
        //this.$store.commit('set_funcs', func)
      },
      async close (routeName) {
        let msg = '是否退出竞价大厅?'
        if ((this.$route.name === 'pbrCenterForm') && routeName === 'pbrCenterForm') {
          if (+this.$store.getters.loginUser.comtype === 3 && !this.pbrCenterInfo.endbjBoolean) {
            let { issuccess = -1 } = await request({
              method: 'get',
              url: '/xmgl/pbr/getPbrByComid',
              params: { pbrprojectid: this.pbrCenterInfo.pbrprojectid, pbrcomid: this.$store.getters.loginUser.comid, pbtseq: this.pbrCenterInfo.pbtseq }
            })
            if (issuccess === -1) {
              msg = '您尚未在网上大厅报价（不报价视同自动放弃本项目），是否退出大厅？'
            }
            console.log(this.pbrCenterInfo)
          }
          this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$store.commit('SET_ISPBRCENTERCLOSE', 3)
            this.$store.commit('close_tab', {routeName: routeName, vm:this, newRouteName:''})
          }).catch(() => {
          })
        } 
        else if ((this.$route.name === 'pbrTenderForm') && routeName === 'pbrTenderForm') {
          this.$confirm('是否退出开标大厅?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$store.commit('SET_ISPBRTENDERFORMCLOSE', 3)
            this.$store.commit('close_tab', {routeName: routeName, vm:this, newRouteName:''})
          }).catch(() => {
          })
        } 
         else if ((this.$route.name === 'auctionHall') && routeName === 'auctionHall') {
          this.$confirm('是否退出竞拍大厅?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$store.commit('SET_ISAUCTIONHALLCLOSE', 3)
            this.$store.commit('close_tab', {routeName: routeName, vm:this, newRouteName:''})
          }).catch(() => {
          })
        } 
        else this.$store.commit('close_tab', {routeName: routeName, vm:this, newRouteName:''})
      }
    },
    watch: {
      $route: {
        handler: function(val, oldVal){
          let idx
          if (oldVal.name === 'pbrCenterForm') {
            idx = this.tabRoutes.findIndex(item => item.name === 'pbrCenterForm')
          }
          if (oldVal.name === 'pbrTenderForm') {
            idx = this.tabRoutes.findIndex(item => item.name === 'pbrTenderForm')
          }
          if (this.ispbrCenterClose === 0 && !idx) {
            this.$store.commit('SET_ISPBRCENTERCLOSE', 2)
          } else if (this.ispbrCenterClose === 2 && idx) {
            this.$store.commit('SET_ISPBRCENTERCLOSE', 1)
            idx = -1
          }
          if (this.ispbrTenderFormClose === 0 && !idx) {
            this.$store.commit('SET_ISPBRTENDERFORMCLOSE', 2)
          } else if (this.ispbrTenderFormClose === 2 && idx) {
            this.$store.commit('SET_ISPBRTENDERFORMCLOSE', 1)
            idx = -1
          }
          if (this.isauctionHallClose === 0 && !idx) {
            this.$store.commit('SET_ISAUCTIONHALLCLOSE', 2)
          } else if (this.isauctionHallClose === 2 && idx) {
            this.$store.commit('SET_ISAUCTIONHALLCLOSE', 1)
            idx = -1
          }
          this.currentPath = val.path
        },
        deep: true
      }
    }
  }
</script>
<style lang="scss" scoped>
a:visited {
  color:#666
}
.swiper-slide {
  width: auto;
  min-width: 126px;
  display: flex;
  height: 50px;
  flex-direction: column;
  justify-content: center;
  background-color: #fff;
  color: #666;
}
.reuse-tab-wrap {
  bottom: 0;
  left: 0;
  user-select: none;
  height: 50px;
  // background: #EEF4F9;
  font-size: 14px;
  color: #8c98ae;
  display: flex;
  align-items: center;
  overflow: hidden;
  .reuse-tab-item {
    box-sizing: border-box;
    width: auto;
    height: 50px;
    min-width: 126px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 1em;
    margin-right: 1px;
    position: relative;
    white-space: nowrap;
    > i {
      color: #3963bc;
    }
    .el-icon-close {
      opacity: 0;
      position: absolute;
    }
    &:visited {
      color: #8c98ae;
    }
     &:hover {
      background: #f5f5f5;
      border-top: 2px solid #f46722;
      color: #333 !important;
      // border: none;
      font-weight: bold;

      > i {
        color: #fff;
      }

      .el-icon-close {
        position: absolute;
        display: inline-block;
        width: 18px;
        height: 18px;
        top: 0;
        right: 0;
        opacity: 1;
        border-radius: 0 0 0 14px;
        background: rgba(255, 255, 255, 0.3);

        &::before {
          font-size: 18px;
          position: absolute;
          right: -1px;
          transform: scale(0.7);
        }
      }
    }
  }
}
.active {
  box-sizing: border-box;
  height: 50px;
  // color: #ffffff !important;
  background: #f5f5f5;
  border-top: 2px solid #f46722;
  color: #333 !important;
  // border: none;
  font-weight: bold;
  position: relative;
  > i {
      color: #fff;
    }

  .el-icon-close {
    position: absolute;
    display: inline-block;
    width: 18px;
    height: 18px;
    top: 0;
    right: 0;
    opacity: 1 !important;
    border-radius: 0 0 0 14px;
    background: rgba(255, 255, 255, 0.3);

    &::before {
      font-size: 18px;
      position: absolute;
      right: -1px;
      transform: scale(0.7);
    }
  }
}
.reuse-tab-wrap {
  height: 50px;
  border-bottom: 1px solid #dae1ed;
  border-top: 1px solid #dae1ed;
  background: #fff;
}
.reuse-tab {
  position: relative;
  width: 100%;
  .contextmenu {
    margin: 0;
    background: #ffffff;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    color: #596c8e;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
    li {
      margin: 0;
      padding: 10px 20px;
      cursor: pointer;
      &:hover {
        background: #f5f5f5;
        // color: #6182c9;
        font-weight: bold;
      }
    }
  }
}
.fold {
  display: block;
  height: 54px;
  width: 25px;
  line-height: 52px;
  font-size: 24px;
  margin: 0 10px;
  background: #fff;
  cursor:pointer;
}
</style>
